module.exports = __webpack_public_path__ + "img/BGgreen.9a9e3dc9.png";